import BaseCrudService from "./baseCrud.service";

export default class PermissionService  extends BaseCrudService {

    constructor() {
        super('Permission');
    }

    listAll(){
        return this.getRequest('ListAll');
    }
}